import {Exclude, Expose, instanceToPlain, plainToInstance} from "class-transformer";
import * as t from "io-ts";
import {validateJSON, validateJSONNow} from "../../web/validation";
import {Entity} from "../entity";
import {Violation, ViolationCodec} from "../violation";

export const RrcEp10WasteManifestBuildStatusCodec = t.intersection([
  t.type({
    id: t.string,
    pickupTransportId: t.string,
    status: t.string,
    recommendRegeneration: t.boolean,
    createDttm: t.number,
    lastModifiedDttm: t.number,
  }),
  t.partial({
    deliveryTransportId: t.string,
    violations: t.array(ViolationCodec),
    lastRrcEp10WasteManifestId: t.string,
    lastRrcEp10WasteManifestVersion: t.number,
    snapshotJson: t.string,
    snapshotHash: t.string,
  }),
]);

export type RrcEp10WasteManifestBuildStatus = t.TypeOf<typeof RrcEp10WasteManifestBuildStatusCodec>;

@Exclude()
export class RrcEp10WasteManifestBuildStatusEntity implements Entity {
  @Expose()
  id!: string;

  @Expose()
  pickupTransportId!: string;

  @Expose()
  deliveryTransportId?: string;

  @Expose()
  status!: string;

  @Expose()
  violations?: Violation[];

  @Expose()
  recommendRegeneration!: boolean;

  @Expose()
  lastRrcEp10WasteManifestId?: string;

  @Expose()
  lastRrcEp10WasteManifestVersion?: number;

  @Expose()
  createDttm!: number;

  @Expose()
  lastModifiedDttm!: number;

  readonly entityType = 'RRCEP10WASTEMFSTBLDSTATUS';

  get displayName(): Readonly<string> {
    return this.id;
  }

  /**
   * Constructor for RrcEp10WasteManifestBuildStatusEntity. Recommend using the {@link create} method instead.
   * @hideconstructor
   */
  constructor() {
    // Empty constructor for 'class-transformer'
  }

  static from(value: RrcEp10WasteManifestBuildStatus): RrcEp10WasteManifestBuildStatusEntity {
    return plainToInstance(RrcEp10WasteManifestBuildStatusEntity, value, {
      excludeExtraneousValues: true,
    });
  }

  loadTypeValue(): Promise<RrcEp10WasteManifestBuildStatus> {
    const object = instanceToPlain(this, {
      excludeExtraneousValues: true,
    });
    return validateJSON(RrcEp10WasteManifestBuildStatusCodec, object);
  }

  asTypeValue(): RrcEp10WasteManifestBuildStatus {
    const object = instanceToPlain(this, {
      excludeExtraneousValues: true,
    });
    return validateJSONNow(RrcEp10WasteManifestBuildStatusCodec, object);
  }
}
